import { InfoOutlined } from "@mui/icons-material";
import { Box, IconButton, Popover, Typography, Divider } from "@mui/material";
import PropTypes from "prop-types";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const DescriptionPopover = ({ title, description }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { t } = useTranslation();

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const open = Boolean(anchorEl);

  return (
    <>
      <IconButton size="small" sx={{ p: 0.2 }} onClick={handleOpen}>
        <InfoOutlined fontSize="inherit" color={description ? "primary" : "disabled"} />
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        // Since this is on the left side of the table,
        // we anchor to the right of the icon and grow right.
        anchorOrigin={{
          vertical: "center",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "left",
        }}
        PaperProps={{
          sx: {
            backgroundColor: "#ffffff !important",
            boxShadow: "0px 8px 32px rgba(0,0,0,0.15)",
            borderRadius: "12px",
            width: 350, // Professional width for reading
            maxWidth: "90vw",
            border: "1px solid #e0e0e0",
            overflow: "hidden",
          },
        }}
      >
        <Box sx={{ p: 2, bgcolor: "#f8f9fa" }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 700, color: "primary.main" }}>
            {title}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {t("user.assess.description")}
          </Typography>
        </Box>

        <Divider />

        <Box sx={{ p: 2, maxHeight: 400, overflowY: "auto" }}>
          <Typography
            variant="body2"
            sx={{
              color: "grey.800",
              lineHeight: 1.6,
              whiteSpace: "pre-wrap", // Maintains paragraphs/line breaks
              fontSize: "0.85rem",
            }}
          >
            {description || t("user.assess.noDescription")}
          </Typography>
        </Box>
      </Popover>
    </>
  );
};

DescriptionPopover.propTypes = {
  title: PropTypes.string,
  description: PropTypes.description,
};

export default DescriptionPopover;
